export const RECOVERY_DOMAIN_PREFIX = 'ERT:v1';
// VOPRF suite constant lives in shared/src/crypto/voprf/types.ts

export const DEFAULT_TOKEN_BUCKET_CAPACITY = 200;
export const DEFAULT_TOKEN_BUCKET_REFILL_RATE = 1 / 300; // tokens per second

export const AUTOTUNE_DEFAULT_MEMORY_MIB = 32;
export const AUTOTUNE_MAX_MEMORY_MIB = 512;
export const AUTOTUNE_TARGET_DESKTOP_MS = 2000;
export const AUTOTUNE_TARGET_MOBILE_MS = 1000;
export const AUTOTUNE_PARALLELISM_DESKTOP = 4;
export const AUTOTUNE_PARALLELISM_MOBILE = 2;
export const AUTOTUNE_MAX_ITERATIONS = 10;

export const HKDF_INFO_LABEL = 'ERT:v1|hkdf';
export const HKDF_OUTPUT_BYTES = 32;

// Chaining domains
export const CHAIN_DOMAIN_UPDATE = 'ERT:v1|chain|update:';
export const CHAIN_DOMAIN_FILE = 'ERT:v1|chain|file:';

export const AES_GCM_IV_LENGTH = 12;
export const AES_GCM_TAG_LENGTH_BITS = 128;

export const JITTER_MIN_MS = 200;
export const JITTER_MAX_MS = 600;

export const TURNSTILE_VERIFY_ENDPOINT =
  'https://challenges.cloudflare.com/turnstile/v0/siteverify';

export const DEV_TURNSTILE_BYPASS_TOKEN = 'ers-dev-turnstile-token';

// P256 blinded element is ~66 bytes raw, ~88 bytes base64url
// Allow small buffer for encoding variations
export const MAX_BLINDED_BASE64_LENGTH = 128;
